var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "post-details"
  }, [_c('div', {
    staticClass: "post-details-row heading-3-large"
  }, [_vm._v(_vm._s(_vm.post.details.title))]), _c('div', {
    staticClass: "post-details-row paragraph-1-large",
    domProps: {
      "innerHTML": _vm._s(_vm.post.details.content)
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }